var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroOpenDownBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.999,
    viewBox: "0 0 24 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(-965 -66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "comment-code",
    d: "M24,19V12.34A12.208,12.208,0,0,0,12.836.029,12,12,0,0,0,.03,12.854C.47,19.208,6.082,24,13.084,24H19a5.006,5.006,0,0,0,5-5ZM12.7,2.024A10.2,10.2,0,0,1,22,12.34V19a3,3,0,0,1-3,3H13.083C7.048,22,2.4,18.095,2.024,12.715A10,10,0,0,1,12.014,2c.228,0,.457.007.686.023Z",
    transform: "translate(964.999 65.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "comment-code-2",
    "data-name": "comment-code",
    d: "M14.881,17a1,1,0,0,1-.707-1.707l2.536-2.536a1,1,0,0,0,0-1.414L14.074,8.707a1,1,0,0,1,1.414-1.414l2.636,2.636a3.006,3.006,0,0,1,0,4.242l-2.536,2.536a1,1,0,0,1-.707.293Z",
    transform: "translate(989.389 62.608) rotate(90)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroOpenDownBtn);
export default __webpack_public_path__ + "static/media/Asset-KuroOpenDownBtn.ffde3b17a72c4be393d5728b3dd3ae1a.svg";
export { ForwardRef as ReactComponent };